import React from 'react';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';

import Accordion, {
  AccordionContent,
  AccordionTitle
} from 'buyside/components/presentation/Accordion/accordionComponents';
import { MediaTypes } from 'buyside/components/presentation/MediaShowPage/mediaShowPage';
import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from 'buyside/components/presentation/Skeleton/skeleton';

import { useIsMobile } from 'buyside/util/hooks/useIsMobile';

import styles from './mediaShowPageStyles.scss';

const MediaShowPageLoading: React.FC<{ mediaType: MediaTypes }> = ({ mediaType }) => {
  const isMobile = useIsMobile();

  return (
    <>
      <div className={styles.mediaHeader}>
        <h3>
          <Skeleton width={SKELETON_WIDTHS.LARGE} size={SKELETON_SIZES.LARGE} />
        </h3>
        <p>
          <Skeleton width={SKELETON_WIDTHS.SMALL} />
        </p>
      </div>
      <div className={styles.mediaBody}>
        <div>
          {mediaType === MediaTypes.VIDEO ? (
            <Skeleton size={SKELETON_SIZES.FULL} containerHeight={isMobile ? 350 : 450} />
          ) : (
            <div className={styles.mockedIframe}>
              <p>
                <Skeleton width={SKELETON_WIDTHS.LARGE} />
              </p>
              {isMobile ? (
                <>
                  <p>
                    <Skeleton width={SKELETON_WIDTHS.SMALL} />
                  </p>
                </>
              ) : (
                <>
                  <p>
                    <Skeleton width={SKELETON_WIDTHS.MEDIUM} />
                  </p>
                  <p>
                    <Skeleton width={SKELETON_WIDTHS.SMALL} />
                  </p>
                </>
              )}
            </div>
          )}
          <div>
            <p>
              <Skeleton width={SKELETON_WIDTHS.FULL} />
              <Skeleton width={SKELETON_WIDTHS.FULL} />
              <Skeleton width={SKELETON_WIDTHS.FULL} />
              <Skeleton width={SKELETON_WIDTHS.LARGE} />
            </p>
          </div>
        </div>
        <Accordion>
          <AccordionTitle collapseIcon={faMinus} expandable expandIcon={faPlus}>
            Related Episodes
          </AccordionTitle>
          <AccordionContent>
            {[...Array(3).keys()].map(idx => (
              <div key={`media-${idx}`} className={styles.relatedMedia}>
                <a>
                  <Skeleton />
                  <Skeleton width={SKELETON_WIDTHS.ONE_THIRD} />
                </a>
                <p>
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                </p>
              </div>
            ))}
          </AccordionContent>
        </Accordion>
      </div>
    </>
  );
};

export default MediaShowPageLoading;
